import { render, staticRenderFns } from "./rgpd.vue?vue&type=template&id=5fddf7b8"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fddf7b8')) {
      api.createRecord('5fddf7b8', component.options)
    } else {
      api.reload('5fddf7b8', component.options)
    }
    module.hot.accept("./rgpd.vue?vue&type=template&id=5fddf7b8", function () {
      api.rerender('5fddf7b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/rgpd.vue"
export default component.exports